import React from "react"
import Layout from "../../components/Layout"
import SEO from "../../components/Seo"
import Hero from "../../components/Services/Hero"
import OurServices from "../../components/Services/OurServices"
import Tecnology from "../../components/Services/Tecnology"
import Beneficios from "../../components/Services/Beneficios"

const Services = () => {
  return (
    <Layout>
      <SEO title="Services" />
      <Hero />
      <OurServices />
      <Tecnology />
      <Beneficios />
    </Layout>
  )
}

export default Services
